import React, { useState } from "react";
import "./Concepts.css";
import GeriButonu from "../components/GeriButonu";
import { useAlert } from "../context/AlertContext";
import conceptList from "../data/conceptList";

export default function Concepts() {
  const [selectedImage, setSelectedImage] = useState(null);
  const { showSuccess } = useAlert(); // şimdilik kullanılmıyor

  return (
    <div className="concepts-page">
      <GeriButonu />

      <h2>Konsept Görselleri</h2>

      <div className="concept-grid">
        {conceptList.map((concept) => (
          <div
            key={concept.name}
            className="concept-item"
            onClick={() => setSelectedImage(concept)}
          >
            <img src={concept.image} alt={concept.name} />
            <p>{concept.name}</p>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage.image} alt={selectedImage.name} />
        </div>
      )}
    </div>
  );
}
